module.exports = __webpack_public_path__ + "img/1.d9305962.jpg";